<template>
  <div v-if="(!loaded)"><AppSpinner /></div>
  <div v-if="(loaded)">
    <iframe :src="player" style="width: 100%; aspect-ratio: 1/0.67;"></iframe>
  </div>
</template>

<script>
export default {
  inject: ['dialogRef'],
  components: {},
  data() {
    return {
      loaded: false,
      player: this.dialogRef.data.player,
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.loaded = true;
      this.mt_isMobile();
    },
    mt_isMobile() {
      if (!this.fc_isMobile()) {
        this.loaded = true;
      }
      else {
        window.open(this.dialogRef.data.player, '_blank', 'noreferrer');
        this.dialogRef.close();
      }
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
